import * as React from 'react';

import Alert from '@mui/material/Alert';

import Typography from '@mui/material/Typography';

import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SearchIcon from '@mui/icons-material/Search';
import LayersIcon from '@mui/icons-material/Layers';
import LayersClearIcon from '@mui/icons-material/LayersClear';
import LinkIcon from '@mui/icons-material/Link';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { GB, DE } from 'country-flag-icons/react/3x2'


export default function DisclaimerEn() {
	// define GUI elements
	return (
		<React.Fragment>
			<Alert severity="info">
				The preview does not contain information on seminars, advanced software lab and project work. Please note the usage instructions.
				In the preview, the guaranteed course language is indicated. In particular, advanced modules in
				German (<DE title="German" style={{width: '1em'}}/>) can possibly also be studied in
				English (<GB title="English" style={{width: '1em'}}/>). Especially for modules in <DE title="German" style={{width: '1em'}}/> that
				have been given as conditional modules (see your admission letter), there is usually  
				a <GB title="English" style={{width: '1em'}}/> study possibility. For modules in <GB title="English" style={{width: '1em'}}/>, the
				examination can usually also be taken in <DE title="GERMAN" style={{width: '1em'}}/>. If in doubt, please contact the lecturer.
			</Alert>
			<Accordion>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1-content"
					id="panel1-header"
				>
					Usage instructions & legend
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						This preview is <b>not binding</b>.
						Information about the courses in the current semester can be found in more detail on MARVIN.
						Information about the courses for the following semester can be found on MARVIN from March (for a summer semester) or September (for a winter semester).						</Typography>
					<Typography>
						The courses in this preview do not include seminars, individual internships ("Advanced Software Lab",
						"Project Work"), "Final Theses" and the module "Independent Scientific Practice".
						Such courses are still offered every semester.
						They are not included in this list because they are usually offered at short notice.
						Please consult MARVIN for the seminars offered this or next semester.
						For the internships, please visit the corresponding ILIAS course to see available tasks
						(new tasks are usually provided and assigned at the beginning of the lecture period,
						registration for this course will also open then):
						"ILIAS: Kurse aller Semester" &gt; "Fb. 12: Mathematik und Informatik" &gt; "Informatik" &gt; "Softwaretechnik" &gt; <i>current Semester</i> &gt; "Taentzer: SO Fortgeschrittenenpraktika und Projektarbeiten".
						If you are looking for a task for a thesis, please visit the working group websites or
						contact the professors or assistants directly.
					</Typography>
					<Typography>
						You can use the <FilterAltIcon /> button to set the grouping and filtering
						options according to your course of study and the modules that particularly interest you.
						Reset all filters and grouping settings using the <FilterAltOffIcon/> button.
						Using the search field (<SearchIcon />), you can quickly reduce the displayed preview
						to courses for which either the title or the instructors correspond to the search term.
						You can use the <LayersIcon /> button to hide the display of details in the table;
						to show them again press <LayersClearIcon />. The <LinkIcon /> button allows you to
						copy a link to the preview to your clipboard that contains your current filter settings.					</Typography>
					<Typography>
						For each course, in addition to the name and the responsible lecturers, the following properties are displayed in square brackets:
						<Typography component='li'>Level.</Typography>
						<Typography component='li'>Amount in credit points.</Typography>
						<Typography component='li'>Course language.</Typography>
						<Typography component='li'>Characteristics (&#129513;) that may limit eligibility in a field of study.
						The meaning of the characteristics is described in the examination regulations for your course of study.
						The most relevant features are:
							<Typography component='li'><b>P</b> - Practical Computer Science</Typography>
							<Typography component='li'><b>T</b> - Theoretical Computer Science</Typography>
							<Typography component='li'><b>I</b>, <b>Inf</b> - Computer Science</Typography>
							<Typography component='li'><b>M</b> - Mathematics</Typography>
							<Typography component='li'><b>A</b> - Applied Mathematics (or variant A)</Typography>
							<Typography component='li'><b>R</b> - Pure Mathematics</Typography>
							<Typography component='li'><b>gestr</b> - Study program in the extended variant</Typography>
							<Typography component='li'><b>S</b> - Application area Languages</Typography>
							<Typography component='li'><b>GI</b> - Application area Geoinformatics</Typography>
							<Typography component='li'><b>SW</b> - Application area Social Sciences</Typography>
							<Typography component='li'><b>MI</b> - Application area Medical Informatics</Typography>
						</Typography>
						When you hover over or touch an event, the properties are displayed in more detail in a tooltip.
						The department's online module handbook is also linked from there.
						This will take you to the module handbook entry for a course of study, a field of study or the module (&#128214;) within the field of study.
					</Typography>

				</AccordionDetails>
			</Accordion>
		</React.Fragment>
	);
}